import { Box, Modal, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import { WorkflowStepAction } from '@spike/masterdata-model';
import { FunctionComponent } from 'react';
import ListItem, { redAppointementStatusIds } from './ListItem';
import { ActionsPopup } from 'components/UI/ActionsPopup/ActionsPopup';
import { ActionButtonType } from 'components/UI/ActionsPopup/ActionButton';

export interface ListProps {
    actions: Array<WorkflowStepAction>;
    className?: string;
    onClick?: (statusId: number) => void;
    onClose: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            position: 'absolute',
            zIndex: 100,
            right: 0,
            top: 45,
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 14,
            border: '1px solid #000',
            background: '#FFF',
            padding: '10px 20px'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    })
);

export const List: FunctionComponent<ListProps> = props => {
    const classes = useStyles();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const webView = (
        <Box className={classes.container}>
            {props.actions.map(step => (
                <ListItem
                    key={step.nextStatus.id}
                    step={step}
                    onClick={() => props.onClick && props.onClick(step.nextStatus.id)}
                />
            ))}
        </Box>
    );

    const mobilePopupActions: Array<ActionButtonType> = props.actions.map(step => ({
        label: step.nextStatus.name,
        onClick: () => props.onClick && props.onClick(step.nextStatus.id),
        color: redAppointementStatusIds.includes(step.nextStatus.id) ? '#EF4F57' : undefined
    }));

    const mobileView = (
        <Modal
            open={true}
            aria-labelledby="simple-dialog-title"
            className={classes.modal}
        >
            <ActionsPopup
                actions={mobilePopupActions}
                onClose={props.onClose}
            />
        </Modal>
    );

    return isMobile ? mobileView : webView;
};

export default List;
